import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    // backgroundColor: theme.mixins.Black(),
    backgroundColor: theme.palette.background.default,
    '& h2': {
      color: theme.mixins.Black(),
      paddingBottom: theme.spacing(2),
    },
    '& .review-cards:first-child': {
      ...theme.mixins.marginLeft(theme.spacing(3)),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginLeft(theme.spacing(0)),
      },
    },
    '& .review-cards': {
      flex: 1,
    },
  },
  ratingImageWithLogo: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
  },
  tripAdvisorTitle: {
    '& h2': {
      color: theme.palette.text.sectionHeading,
    },
    '&.MuiTypography-h2': {
      [theme.breakpoints.up('lg')]: {
        paddingBottom: theme.spacing(2.5),
      },

    },
  },
  description: {
    color: theme.palette.text.darkGrey,
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(4.5),
    },
  },
  headingGrid: {
    paddingTop: `${theme.spacing(6)}`,
    [theme.breakpoints.up('lg')]: {
      paddingTop: `${theme.spacing(11)}`,
    },
  },
  reviewsSection: {
    top: theme.spacing(-11),
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      top: theme.spacing(-12),
    },
  },

  heading: {
    color: theme.mixins.Black(),
    '&:before': {
      backgroundColor: theme.mixins.Black(),
    },
  },
  reviews: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'scroll',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  editReviews: {
    display: 'flex',
    '& .MuiTypography-colorPrimary': {
      color: theme.mixins.AbuDhabiOrange(),
    },
  },
  deskTopReviews: {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  totalReviews: {
    padding: `${theme.spacing(2)} 0`,
    color: theme.palette.text.tertiary,
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.borderRight(`1px solid ${theme.mixins.Black(200)}`),
      padding: '0',
      ...theme.mixins.marginRight(theme.spacing(3)),
      ...theme.mixins.paddingRight(theme.spacing(3)),
    },
  },
  readReviews: {
    ...theme.mixins.marginRight(theme.spacing(4)),
  },
  overViewSection: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(18),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  rating: {
    height: pxToRem(40),
    display: 'inline-flex',
    '& img': {
      height: theme.spacing(3),
      width: 'auto',
      position: 'relative',
      left: pxToRem(-12),
      top: theme.spacing(1),
      background: theme.palette.background.transparent,
    },
  },
}));

export default useStyles;
